// ABOUTME: Dashboard hook for guest (unauthenticated) users.
// ABOUTME: Same API shape as useDashboard but backed by localStorage via guestDashboardService.

import { useState, useCallback } from "react";
import { guestDashboardService } from "../services/guestDashboardService";
import type { DashboardItem } from "../services/dashboardService";

export function useGuestDashboard() {
  const [dashboardItems, setDashboardItems] = useState<DashboardItem[]>(() =>
    guestDashboardService.getDashboard()
  );

  const refresh = () => setDashboardItems(guestDashboardService.getDashboard());

  const addDashboardItem = useCallback((item: Omit<DashboardItem, "id">) => {
    const id = guestDashboardService.addItem(item);
    refresh();
    return id;
  }, []);

  const updateDashboardItem = useCallback((itemId: string, updates: Partial<DashboardItem>) => {
    guestDashboardService.updateItem(itemId, updates);
    refresh();
  }, []);

  const deleteDashboardItem = useCallback((itemId: string) => {
    guestDashboardService.deleteItem(itemId);
    refresh();
  }, []);

  const updateDashboardLayout = useCallback(async (items: DashboardItem[]) => {
    guestDashboardService.setDashboard(items);
    setDashboardItems(items);
  }, []);

  return {
    dashboardItems,
    loading: false,
    error: null,
    addDashboardItem,
    updateDashboardItem,
    deleteDashboardItem,
    updateDashboardLayout,
  };
}
